import React, { useEffect } from "react";
import styles from './index.pcss';
import classNames from 'classnames/bind';
import { replaceWithJioCDN } from "../../../utils/imageHandling";

interface ModuleData {
  imageLink: string;
  imageName: string;
  text?: string;
  isSelected: boolean;
  finalStep?: boolean;
  isDeskTop?: boolean;
  inputType?:string;
  onActivate?: (event: React.SyntheticEvent) => void;

}

const cx = classNames.bind(styles);

const getClassNamesForStep = (finalStep: boolean, isSelected: boolean, isDeskTop:boolean) => {               //change the css classes based on final step and step 1-3 UI difference
  return {
    imageModuleContainer: finalStep ? (isDeskTop ? 'desktopImageModuleContainerStep4' : 'imageModuleContainerStep4') : (isDeskTop ? 'desktopImageModuleContainer' : 'imageModuleContainer'),
    flexBoxImage: finalStep ? (isDeskTop ? 'desktopFlexBoxImageStep4' : 'flexBoxImageStep4') : 'flexBoxImage',
    imageContainer: finalStep ? 'imageContainerStep4' : 'imageContainer',
    imageLink: finalStep ? 'imageLinkStep4' : 'imageLink',
    imageName: finalStep ? 'imageNameStep4' : 'imageName',
    selectedImageModuleContainer: isSelected ? (finalStep ? 'selectedImageModuleContainerStep4' : 'selectedImageModuleContainer') : '',
    inputBox: isDeskTop ? "desktopInputBox" : "inputBox",
    imageNameText: isDeskTop ? "desktopImageNameText" : "imageNameText",
  };
};

const BRTImageModule = ({ imageLink, imageName, isSelected, finalStep = false, text = "",isDeskTop = false,inputType="checkbox", onActivate }: ModuleData) => {        //change step with step
  const classNamesForStep = getClassNamesForStep(finalStep,isSelected, isDeskTop);

  const kill = (e: React.SyntheticEvent) => {
    e.preventDefault?.();
    e.stopPropagation?.();
  
    e.nativeEvent?.stopImmediatePropagation?.();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " " || e.key === "Enter") {
      kill(e);
      onActivate?.(e);
    }
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === " " || e.key === "Enter") {
      kill(e);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    kill(e);
    onActivate?.(e);
  };


  return (
    <div className={cx(classNamesForStep.imageModuleContainer, classNamesForStep.selectedImageModuleContainer)} tabIndex={finalStep? -1 : 0} aria-hidden={!isDeskTop} >
      <div className={cx(classNamesForStep.flexBoxImage)}>
        <div className={cx(classNamesForStep.imageContainer)} >
          {finalStep ?
          <>
          {
          inputType==="checkbox"?
                <input
                  type="checkbox"
                  aria-labelledby={`label-${imageName.replace(/\s+/g, '-')} label-${imageName.replace(/\s+/g, '-')}-2`}
                  tabIndex={-1}
                  onKeyDown={finalStep ? handleKeyDown : undefined}
                  onClick={finalStep ? handleClick : undefined}
                  onKeyUp={finalStep ? handleKeyUp : undefined}
                  className={cx(classNamesForStep.inputBox)}
                  checked={isSelected}
                />
          :
          <input type={inputType} className={cx(classNamesForStep.inputBox)} checked={isSelected} tabIndex={-1} />              
          }</>:
           null}
          <img src={imageLink} alt="" aria-hidden="true" className={cx(classNamesForStep.imageLink)} />
        </div>
      </div>
      <div className={cx('textContainer')}  {...(inputType === "checkbox" ? { 'aria-hidden': true } : {})}>
        <div id={`label-${imageName.replace(/\s+/g, '-')}`} className={cx(classNamesForStep.imageName)}>
          {finalStep ? imageName : <p className={cx(classNamesForStep?.imageNameText)}>{imageName}</p>}
        </div>
        {finalStep ? <div id={`label-${imageName.replace(/\s+/g, '-')}-2`} className={cx('imageText')} >{text}</div>: null}
      </div>
      
    </div>
  );
};

export default BRTImageModule;
